import { baseApolloClient } from './client'
import type { Media } from './generated/graphql'
import { GetMediaDocument, UploadMediaDocument } from './generated/graphql'
import {
  createFetchQueryHelper,
  createMutationHelper,
  createQueryHook,
  modifyQueryHook,
} from './utils'

export const useGetMedia = modifyQueryHook(
  createQueryHook(GetMediaDocument, {
    // Media data should be stable, so no need to refetch all the time
    fetchPolicy: 'cache-first',
    context: { refetchOnFocus: false, refetchOnReconnect: false },
  }),
  {
    transform: (id: string) => ({ id }),
    reduce: r => r?.media,
  },
)
export const fetchGetMedia = createFetchQueryHelper(GetMediaDocument)

export const updateGetMedia = (id: string, data: Media) => {
  baseApolloClient.refetchQueries({
    updateCache(cache) {
      cache.updateQuery({ query: GetMediaDocument, variables: { id } }, () => ({
        media: data,
      }))
    },
  })
}

export const [useUploadMedia, executeUploadMedia] =
  createMutationHelper(UploadMediaDocument)
